import { ScrollableList } from '@ps/isp-web-component-library';
import type { RaceId } from '@ps/isp-web-services-types';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { SportsLink } from '@swf/sports/components/SportsLink/SportsLink';
import { ariaLabelScrollLeft, ariaLabelScrollRight } from '@swf/sports/utils/getAriaLabels';
import { getRaceTimeFromRaceId } from '@swf/sports/utils/getRaceTimeFromRaceId';

import styles from './Meeting.scss';

const Meeting = ({ raceIds }: { raceIds: RaceId[] }) => {
  const races = useSelector((state: RootState) => select.quickSwitcher.races(state, raceIds));
  const meeting = useSelector((rootState: RootState) =>
    select.quickSwitcher.meeting(rootState, races?.[raceIds[0]]?.meetingId)
  );
  const eventType = useSelector((rootState: RootState) =>
    select.quickSwitcher.eventType(rootState, races?.[raceIds[0]]?.eventTypeId)
  );

  const { formatMessage } = useRegulatoryIntl();
  const { raceId, meetingId } = useSelector(select.sports.getUrlParams);

  const activeRaceId = `${meetingId}.${raceId}`;

  if (!races || !meeting || !eventType) return null;

  const baseLinkValues = {
    eventTypeId: eventType.eventTypeId,
    eventTypeSlug: eventType.eventTypeSlug,
    venueSlug: meeting.venueSlug,
    meetingId: meeting.meetingId
  };

  return (
    <div className={styles.meeting}>
      <span className={styles.venue}>{meeting.venue}</span>
      <ScrollableList
        variant="square-scroll-arrows"
        space="xs"
        slotProps={{
          previousButton: {
            'aria-label': formatMessage(ariaLabelScrollLeft)
          },
          nextButton: {
            'aria-label': formatMessage(ariaLabelScrollRight)
          }
        }}
      >
        {Object.values(races).map((race) => (
          <ScrollableList.Pill
            key={`race_${race.raceId}`}
            as={SportsLink}
            active={race.raceId === activeRaceId}
            alias="sportsAnimalRacingRace"
            role="link"
            values={{
              ...baseLinkValues,
              raceId: getRaceTimeFromRaceId(race.raceId)
            }}
          >
            <FormattedDateTime date={race.startTime} />
          </ScrollableList.Pill>
        ))}
      </ScrollableList>
    </div>
  );
};

export default Meeting;
